/**
 * Session Lock Conflict Modal
 * 
 * Displays a modal when a user tries to edit a resource that is locked by another user.
 * Shows a simple message that the schedule is being edited.
 */

import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import LHModalPop from '../../../components/LHModalPop';
import { RootState } from '../../../store/index';
import { hideSessionLockConflictModal } from '../../../store/slices/sessionLockSlice';

/**
 * Session Lock Conflict Modal Component
 * 
 * Displayed when:
 * - User attempts to edit a resource that is locked by another user
 * - Lock conflict response is received (423 status)
 * 
 * Shows:
 * - Simple message: "Schedule is currently being edited by {User Name}"
 */
export const SessionLockConflictModal: React.FC = () => {
  const dispatch = useDispatch();
  const { isLockConflictModalVisible, lockConflictData } = useSelector(
    (state: RootState) => state?.sessionLock || { isLockConflictModalVisible: false, lockConflictData: null }
  );

  const handleClose = () => {
    dispatch(hideSessionLockConflictModal());
  };

  if (!lockConflictData) {
    return null;
  }

  // Get the user name who has the lock
  const lockedByName = lockConflictData.lockedByName || lockConflictData.lockedBy;
  const resourceType = lockConflictData.resourceType || 'Schedule';

  return (
    <LHModalPop
      visible={isLockConflictModalVisible}
      onClose={handleClose}
      title="Edit in progress"
      description={`${resourceType} is currently being edited by ${lockedByName}`}
      showFooter={true}
      primaryButtonText="Close"
      onPrimaryPress={handleClose}
      secondaryButtonText=""
      showCloseButton={true}
    >
    </LHModalPop>
  );
};

const styles = StyleSheet.create({});

export default SessionLockConflictModal;
